import React, { Component } from "react";
import { Carousel } from "antd";

import BalanceAccountingConfig from "./BalanceAccountingConfig";
import BalanceModels from "./BalanceModels";

class BalanceUpload extends Component {
  render() {
    const props = {
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    return (
      <div>
        <Carousel ref={this.props.carouselRef} {...props}>
          <div>
            <BalanceAccountingConfig />
          </div>
          <div>
            <BalanceModels
              handleNextToAnnexeUpload={this.props.handleNextToAnnexeUpload}
              handleSaveBalance={this.props.handleSaveBalance}
              loadingBalance={this.props.loadingBalance}
            />
          </div>
        </Carousel>
      </div>
    );
  }
}

export default BalanceUpload;



// WEBPACK FOOTER //
// ./src/components/BalanceUpload/BalanceUpload.js